import { render, staticRenderFns } from "./cModalExpense.vue?vue&type=template&id=f2aeda86&scoped=true"
import script from "./cModalExpense.vue?vue&type=script&lang=js"
export * from "./cModalExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aeda86",
  null
  
)

export default component.exports